function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__btn-graphic_small",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "prefix__btn-graphic_small_surface",
    width: 29,
    height: 29,
    rx: 5,
    style: {
      fill: "#efebf6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__ic_edit_24px",
    d: "M3 15.043v3.169h3.169l9.347-9.347L12.347 5.7zm14.967-8.629a.842.842 0 0 0 0-1.192L15.99 3.245a.842.842 0 0 0-1.192 0l-1.546 1.546 3.169 3.169 1.547-1.547z",
    transform: "translate(4.026 4.029)",
    style: {
      fill: "#7644c9"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.08bf044ed8ff3642623dda745d9d1938.svg";
export { ForwardRef as ReactComponent };